import React from "react"
import PropTypes from "prop-types"

class Contacts extends React.Component {

  render() {
    const { contacts, contactSelected } = this.props;
    if (contacts.length == 0) {
      return null;
    }
    return (
      <table id="contact_details" className="table table-condensed">
        <thead>
          <tr>
            <th style={{ width: "10px" }}></th>
            <th>Person</th>
            <th>{I18n.t('branch')}</th>
            <th>{I18n.t('company')}</th>
          </tr>
        </thead>
        <tbody>
          {contacts.map(contact =>
            <tr key={contact.id}>
              <td>
                <input
                  name="contact_id"
                  type="checkbox"
                  checked={contact.checked}
                  value={contact.id}
                  onChange={() => contactSelected(contact)} />
              </td>
              <td>{contact.name}</td>
              <td>{contact.company_branch_name}</td>
              <td>{contact.company_name}</td>
            </tr>
          )}
        </tbody>
      </table>
    )
  }
}

export default Contacts;